import { ADD_UPLOADED_CLAIMS, ADD_VIEW_CLAIMS, SET_UPLOAD_CHECK, IS_RECENT_BATCH, READY_ALL_CLICK} from "./upload/actions";
import { ADD_QUEUED_CLAIMS } from "./claims_table/actions";

const initialState = {
  uploaded_claims: [],
  queued_claims: [],
  view_claims: [],
  upload_check: false,
  is_recent_batch:false,
  ready_all_click: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADD_UPLOADED_CLAIMS:
      return Object.assign({}, state, {
        uploaded_claims: action.payload
      });
    case ADD_QUEUED_CLAIMS:
      return Object.assign({}, state, {
        queued_claims: action.payload
      });
    case ADD_VIEW_CLAIMS:
      return Object.assign({}, state, {
        view_claims: action.payload
      });
      case SET_UPLOAD_CHECK:
      return Object.assign({}, state, {
        upload_check: action.payload
      });
      case IS_RECENT_BATCH:
      return Object.assign({}, state, {
        is_recent_batch: action.payload
      });
      case READY_ALL_CLICK:
      return Object.assign({}, state, {
        ready_all_click: action.payload
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/submit_claims/Reducer.Submit_Claims.js